module.exports = __webpack_public_path__ + "static/fotolog-adc3c7c374092aa643e8a407e0768d8e.png";